import axios from "axios";
import { API_BASE_URL } from "../../../constants";

// Coach Mode V2 API client (same conventions as the brand + athlete clients).

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const unwrapError = (error) => {
  if (error.response) {
    const detail = error.response.data
      ? error.response.data.error || error.response.data.detail || JSON.stringify(error.response.data)
      : error.response.statusText;
    throw new Error(`HTTP ${error.response.status}: ${detail}`);
  }
  throw error;
};

const get = async (path, params) => {
  try {
    const response = await axios.get(`${API_BASE_URL}${path}`, { headers: authHeaders(), params });
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
};

const send = async (method, path, body, params) => {
  try {
    const response = await axios({ method, url: `${API_BASE_URL}${path}`, data: body, params, headers: authHeaders() });
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
};

// Team selection params: {teamId, league, teamName, season, coachEmail}
const teamParams = (team, season, coachEmail) => ({
  ...(team ? { teamId: team.teamId, league: team.league, teamName: team.currentTeam } : {}),
  ...(season ? { season } : {}),
  ...(coachEmail ? { coachEmail } : {}),
});

export const fetchCoachHome = (team, season, coachEmail) => get("/coach/home/", teamParams(team, season, coachEmail));
export const fetchCoachTeam = (team, season, coachEmail) => get("/coach/team/", teamParams(team, season, coachEmail));
// Team style for the Performance tab: box-score figures and style factors
// ranked in the league (loaded on its own, after the roster).
export const fetchCoachTeamStyle = (team, season, coachEmail) => get("/coach/team/style/", teamParams(team, season, coachEmail));
export const fetchCoachCircle = (team, season, coachEmail) => get("/coach/circle/", teamParams(team, season, coachEmail));
// Header badge: the Home attention count of the given team (the coach's
// default team when none is passed).
export const fetchCoachBadges = (team, season, coachEmail) => get("/coach/badges/", teamParams(team, season, coachEmail));
// kind: message | notify | request_link
export const logCoachContact = (payload) => send("post", "/coach/contact/", payload);
// My Circle "Message group": logs a message to each of `emails` the coach
// may reach in that team's Circle (the server skips anyone else).
export const logCoachGroupContact = (team, season, emails, coachEmail) =>
  send("post", "/coach/contact/", { emails }, teamParams(team, season, coachEmail));
